module.exports = "https://web-assets.ifttt.com/packs/media/pro_trial/img-hello-card-web-desktop-min-d50e7977.jpg";